import { createSlice} from '@reduxjs/toolkit';
import {getMetaData} from './meta-data-thunk';
import {CRMObjectTypeMetaData, CRMTypeMetaData,PaymentChannelMetaData, TimingRiskMetaData} from '../models/metaData';

export interface MetaDataState {
  paymentChannel: PaymentChannelMetaData[],
  timingRisk: TimingRiskMetaData[],
  crmObjectType: CRMObjectTypeMetaData[],
  crmType: CRMTypeMetaData[],
}

const initialState: MetaDataState = {
  paymentChannel: [],
  timingRisk: [],
  crmObjectType: [],
  crmType:[],
};

export const metaDataSlice = createSlice({
  name: "metaData",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getMetaData.fulfilled, (state, action) => {
      state.paymentChannel = action.payload.paymentChannel;
      state.timingRisk = action.payload.timingRisk;
    });
  },
});

export default metaDataSlice.reducer;